module.exports = __webpack_public_path__ + "static/media/Muller-Thin-DEMO.e16473a5.ttf";